<template>
  <OrderQuery breadcrumbTitle="Returned" :rerenderWithKey="true" />
</template>

<script>
import OrderQuery from '@/components/order/OrderQuery.vue';

export default {
  name: 'OrderOverview',
  components: {
    OrderQuery,
  },
};
</script>

<style></style>
